import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineLibraryBooks } from "react-icons/md";
import { IoIosArrowRoundBack } from 'react-icons/io';

const ExamDetails = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className='container-fluid every_page_mg_top'>
                <div className='row' style={{ backgroundColor: "#F8F9FA" }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-5 mt-5 p-3" style={{ display: "flex", flexDirection: 'column', gap: "10px" }}>
                        <h2>Preparing For MCA Entrance</h2>
                        <p>NIMCET, MCA JNU, MCA BHU, MAH CET MCA, MCA UPSEE, Jamia Millia Islamia, TANCET, MCA DU</p>
                        <h5>You are at the right platform.</h5>
                        <div><Link to="/signin"><button className='exercise_login_btn'>Login</button></Link>
                            <button className='exercise_login_btn'>Create a new account</button></div>
                    </div>
                    <div className="col-md-6">
                        <div className='design_view'>
                            <h3>NIMCET Test Series</h3>
                            <p>Get access to all premium mock papers (Topic wise + Subject wise + Full length mock Papers)
                                <br /><br />
                                Complete Solution, Detailed Result Analysis, All India Rank, Multiple Attempts, WhatsApp Support</p><br />
                            <button className='exercise_login_btn'>Join Now</button>
                        </div>
                    </div>
                </div>
            </div><br/>
            <div className="container">
                <div className='row quiz_list p-5'>
                    {/* <div className="row"><Link to="/ExamView"><IoIosArrowRoundBack className='back_arrow'/></Link></div><br/><br/> */}
                    <div className='text-center'>  <h3>Exam Details</h3></div>

                    The NIMCET (National Institute of Technology MCA Common Entrance Test) is a national-level entrance exam conducted for admission to Master of Computer Applications (MCA) programs at various National Institutes of Technology (NITs) across India. Below are the key details of the exam:<br />
                    <br />
                    <b style={{paddingLeft:"0px"}}>Eligibility Criteria</b><br /><br />
                    <b style={{paddingLeft:"0px"}}>Educational Qualification:</b>

                    Candidates should have a Bachelor’s degree (B.Sc., B.Sc. (Hons), BCA, BIT, B.Tech, or B.E.) of minimum 3 years with Mathematics/Statistics as one of the subjects.
                    A minimum of 60% aggregate marks (or 6.5 CGPA on a 10-point scale) for General/OBC candidates and 55% marks (or 6.0 CGPA) for SC/ST/PwD candidates is required.<br /><br />
                    <b  style={{paddingLeft:"0px"}}>Age Limit:</b>

                    There is no specific age limit for the exam.<br /><br />
                    <b  style={{paddingLeft:"0px"}}>Qualifying Year:</b>

                    Final-year students are also eligible to apply, provided they fulfill eligibility criteria at the time of admission.<br /><br />
                    <b  style={{paddingLeft:"0px"}}>Exam Pattern</b><br />
                    Mode of Exam:<br />

                    The exam is conducted in offline mode (pen-and-paper-based).<br />
                    <b  style={{paddingLeft:"0px"}}>Duration:</b>
                    The exam is of 2 hours.<br />
                    <b  style={{paddingLeft:"0px"}}>Number of Questions:</b>
                    <br />
                    The paper consists of 120 multiple-choice questions (MCQs).<br />
                    Subjects and Marks Distribution:<br /><br />

                    Mathematics: 50 questions (200 marks)<br /><br />
                    Computer Awareness: 20 questions (80 marks)<br /><br />
                    Analytical Ability & Logical Reasoning: 40 questions (160 marks)<br /><br />
                    General English: 10 questions (40 marks)<br /><br />
                    <b  style={{paddingLeft:"0px"}}>Marking Scheme:</b><br />

                    +4 marks for each correct answer.<br />
                    -1 mark for each incorrect answer.<br />
                    No marks are deducted for unattempted questions.<br /><br />
                    <b  style={{paddingLeft:"0px"}}>Syllabus</b>
                    Mathematics:<br />
                    Set theory, Probability, Matrices, Algebra, Calculus, Trigonometry, Coordinate Geometry, Vector Algebra, etc.<br /><br />
                    Computer Awareness:<br />
                    Basics of Computers, Data Representation, Boolean Algebra, Computer Architecture, Networking, and Programming.<br /><br />
                    Analytical Ability & Logical Reasoning:<br />
                    Logical problems, puzzles, patterns, data interpretation.<br /><br />
                    General English:<br />
                    Comprehension, Vocabulary, Grammar, Sentence Correction.<br /><br />
                    Participating NITs<br />
                    The following NITs offer MCA programs via NIMCET:<br />
                    NIT Agartala<br />
                    NIT Allahabad<br />
                    NIT Bhopal<br />
                    NIT Calicut<br />
                    NIT Jamshedpur<br />
                    NIT Kurukshetra<br />
                    NIT Patna<br />
                    NIT Raipur<br />
                    NIT Surathkal<br />
                    NIT Trichy<br />
                    NIT Warangal<br />
                    Application Process<br />
                    Mode: Online through the official NIMCET portal.<br />
                    Documents Required: Scanned photograph, signature, academic certificates, and <br />
                    category certificate (if applicable).<br /><br />
                    Application Fee:<br />
                    General/OBC: Approx. ₹2500<br />
                    SC/ST/PwD: Approx. ₹1250<br /><br />
                    <b  style={{paddingLeft:"0px"}}>Important Dates:</b><br />
                    Notification Release: Around February-March.<br />
                    Exam Date: Usually in May-June.<br />
                    Results and Counseling<br /><br />
                    Results are announced in the form of a rank list.<br />
                    Counseling is conducted online, where candidates can select their preferred NIT based on their rank.<br /><br />
                </div>
            </div>
        </>
    );
};

export default ExamDetails;